import React, { useState } from "react";
import { Button, Collapse, FormGroup } from "react-bootstrap";

import './styles.scss';

const SettingTabWrapper = ({
    title,
    label,
    onChangeScreen = () => {},
    isFormVisible = false,
    styles = null,
    children,
}) => {
    const [isSettingOpen, setSettingOpen] = useState(false);

    return (
        <FormGroup
            className="setting-screen-wrapper"
            style={{...styles}}
        >
            <FormGroup className="setting-screen-wrapper__button-wrapper">
                <Button
                    className={`setting-screen-wrapper__button ${isSettingOpen ? 'active' : ''}`}
                    aria-controls={label}
                    aria-expanded={isSettingOpen}
                    onClick={() => {
                        setSettingOpen(!isSettingOpen);
                        onChangeScreen(isFormVisible);
                    }}
                >
                    <span className={`setting-screen-wrapper__button-icon ${isSettingOpen ? 'open' : ''}`} />
                    {title}
                </Button>
            </FormGroup>
            <Collapse
                in={isSettingOpen}
                className="setting-screen-wrapper__list"
            >
                <FormGroup
                    id={label}
                    className="setting-screen-wrapper__children"
                >
                    {children}
                </FormGroup>
            </Collapse>
        </FormGroup>
    );
};

export default SettingTabWrapper;
